import {Nav} from "rsuite";

const styles = {
    marginBottom: '1rem',
};

const AdminNav = ({ active, onSelect, ...props }) => {
    return (
        <Nav {...props} activeKey={active} onSelect={onSelect} style={styles}>
            <Nav.Item eventKey="users">
                Users
            </Nav.Item>
            <Nav.Item eventKey="skills">Skills</Nav.Item>
            <Nav.Item eventKey="skillTypes">Skill Types</Nav.Item>
            <Nav.Item eventKey="certs">Certificates</Nav.Item>
            <Nav.Item eventKey="userResumes">User Resumes</Nav.Item>
            <Nav.Item eventKey="userEdit">User Edit</Nav.Item>
        </Nav>
    );
};

export default AdminNav;